import React, { useEffect, useRef } from "react";

interface CarouselNavigationProps {
  carouselRef: React.RefObject<HTMLElement>;
  shiftPageDots?: boolean;
  spread?: boolean;
  icons?: any;
  size?: number;
  onPrevious?: () => void;
  onNext?: () => void;
}

const CarouselNavigation: React.FC<CarouselNavigationProps> = ({
  carouselRef,
  shiftPageDots = true,
  spread = false,
  onPrevious,
  onNext
}) => {
  const dotsContainerRef = useRef<HTMLDivElement>(null);

  const handlePrevClick = () => {
    if (onPrevious) return onPrevious();

    if (carouselRef.current) {
      const instance = carouselRef.current.querySelector('.carousel-component');
      if (instance) {
        // Dispatch a custom event that our Carousel component will listen for
        window.dispatchEvent(new CustomEvent('carousel-prev'));
      }
    }
  };

  const handleNextClick = () => {
    if (onNext) return onNext();

    if (carouselRef.current) {
      const instance = carouselRef.current.querySelector('.carousel-component');
      if (instance) {
        // Dispatch a custom event that our Carousel component will listen for
        window.dispatchEvent(new CustomEvent('carousel-next'));
      }
    }
  };

  useEffect(() => {
    if (shiftPageDots && dotsContainerRef.current && carouselRef.current) {
      const observer = new MutationObserver(() => {
        const paginationDots = carouselRef.current?.querySelector(
          ".carousel-pagination"
        );
        if (paginationDots && dotsContainerRef.current) {
          dotsContainerRef.current.appendChild(paginationDots);
          observer.disconnect(); // Stop observing once the dots have been moved
        }
      });

      observer.observe(carouselRef.current, { childList: true, subtree: true });
    }
  }, [shiftPageDots]);

  return (
    <>
      <div ref={dotsContainerRef} className="carousel-dots-container" />
      <div
        className={`carousel-nav-buttons ${spread ? "flex justify-between items-center w-full z-[5] absolute top-1/2 transform -translate-y-1/2" : "flex gap-[12px]"}`}
      >
        <button 
          onClick={handlePrevClick}
          className="carousel-nav-prev"
          aria-label="Previous slide"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        {!spread && <div className="flex-grow" />}
        <button 
          onClick={handleNextClick}
          className="carousel-nav-next"
          aria-label="Next slide"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </>
  );
};

export default CarouselNavigation;